import React from "react";
import { useTranslation } from "react-i18next";
import { FaWhatsapp } from "react-icons/fa";
import { useFloatingWhatsapp } from "./useFloatingWhatsapp";

// # WHY: mirrors ContactDetailsPopup.whatsappHref — backend persists digits-only
// (see OwnerBrandingManager.normalizeWhatsapp), but be defensive about a manually
// edited dashboard value that slipped a "+" or whitespace through before persistence.
function whatsappHref(value: string): string {
  const digits = value.replace(/\D/g, "");
  return `https://wa.me/${digits}`;
}

export const FloatingWhatsAppButton: React.FC = () => {
  const { t } = useTranslation();
  const whatsapp = useFloatingWhatsapp();

  if (!whatsapp) return null;

  const href = whatsappHref(whatsapp);
  const label = t("branding.floatingWhatsapp.label", "Chat on WhatsApp");

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      data-testid="floating-whatsapp-button"
      className="fixed bottom-4 right-4 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg ring-1 ring-black/10 transition-transform hover:scale-105 active:scale-95 sm:bottom-6 sm:right-6 pb-[max(env(safe-area-inset-bottom),0px)]"
    >
      {/* WHY: lucide ships MessageCircle, not the WhatsApp mark, so the glyph comes from
          react-icons (Font Awesome) instead. */}
      <FaWhatsapp size={24} aria-hidden="true" />
    </a>
  );
};

export default FloatingWhatsAppButton;
